/* =========================================================================
   Premium color variant → gallery image filtering
   When a color variant is selected, only the product images whose ALT text
   matches the chosen color are shown in the gallery; all others are hidden.
   Works alongside the theme's existing (Swiper based) media gallery.
   ========================================================================= */
(function () {
  'use strict';

  function galleryFor(input) {
    var el = input;
    while (el && el !== document.body) {
      if (el.querySelector) {
        var g = el.querySelector('.product-media-gallery');
        if (g) return g;
      }
      el = el.parentElement;
    }
    return document.querySelector('.product-media-gallery');
  }

  function slideAlt(slide) {
    var img = slide.querySelector('img');
    return img ? (img.getAttribute('alt') || '').trim().toLowerCase() : '';
  }

  function mainSlides(gallery) {
    return Array.prototype.slice.call(
      gallery.querySelectorAll('.swiper-main > .swiper-wrapper > .swiper-slide')
    );
  }

  function thumbSlides(gallery) {
    return Array.prototype.slice.call(
      gallery.querySelectorAll('.swiper-thumbs > .swiper-wrapper > .swiper-slide')
    );
  }

  function applyFilter(gallery, color) {
    if (!gallery) return;
    color = (color || '').trim().toLowerCase();

    var main = mainSlides(gallery);
    var thumbs = thumbSlides(gallery);
    if (!main.length) return;

    // Does any image actually match this color? If not, keep everything visible.
    var anyMatch = false;
    if (color) {
      anyMatch = main.some(function (s) {
        return slideAlt(s).indexOf(color) !== -1;
      });
    }

    var firstVisible = 0;
    var foundVisible = false;
    main.forEach(function (s, i) {
      var visible = !color || !anyMatch || slideAlt(s).indexOf(color) !== -1;
      s.setAttribute('data-variant-hidden', visible ? 'false' : 'true');
      if (visible && !foundVisible) {
        firstVisible = i;
        foundVisible = true;
      }
    });

    // Keep thumbnails in sync with the main slides (identical media order)
    thumbs.forEach(function (s, i) {
      var ref = main[i];
      var hidden = ref ? ref.getAttribute('data-variant-hidden') === 'true' : false;
      s.setAttribute('data-variant-hidden', hidden ? 'true' : 'false');
    });

    // Refresh the Swiper instances so the layout reflows instantly
    try {
      var mainEl = gallery.querySelector('.swiper-main');
      var thumbsEl = gallery.querySelector('.swiper-thumbs');
      if (mainEl && mainEl.swiper) {
        mainEl.swiper.update();
        mainEl.swiper.slideTo(firstVisible, 0);
      }
      if (thumbsEl && thumbsEl.swiper) {
        thumbsEl.swiper.update();
      }
    } catch (e) { /* gallery not ready yet — ignore */ }
  }

  function selectedColor(input) {
    // Read the currently checked swatch within the same color group
    var name = input.getAttribute('name');
    var checked = document.querySelector('input[name="' + name + '"]:checked');
    return checked ? checked.value : input.value;
  }

  function onColorChange(e) {
    var input = e.target;
    if (!input.matches('.color-swatches input[type="radio"]')) return;
    var gallery = galleryFor(input);
    // Swiper may not be initialised on the very first tick — retry briefly.
    var tries = 0;
    (function run() {
      var mainEl = gallery && gallery.querySelector('.swiper-main');
      if (mainEl && mainEl.swiper) {
        applyFilter(gallery, selectedColor(input));
      } else if (tries++ < 20) {
        requestAnimationFrame(run);
      } else {
        applyFilter(gallery, selectedColor(input)); // fall back: still hide via CSS
      }
    })();
  }

  document.addEventListener('change', onColorChange);

  // Apply the initial filter for the pre-selected colour once galleries exist.
  function initAll() {
    document.querySelectorAll('.color-swatches input[type="radio"]:checked').forEach(function (input) {
      var gallery = galleryFor(input);
      if (gallery) applyFilter(gallery, selectedColor(input));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(initAll, 400); });
  } else {
    setTimeout(initAll, 400);
  }
})();


/* =========================================================================
   "The Fabric" page — scroll reveal + count-up (CSS-first, tiny JS)
   ========================================================================= */
(function () {
  'use strict';
  if (window.__fabricInit) return;
  window.__fabricInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-fabric-count'));
    if (isNaN(target)) return;
    var decimals = (el.getAttribute('data-fabric-decimals') | 0);
    var dur = 1400, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(decimals);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = target.toFixed(decimals);
    }
    requestAnimationFrame(step);
  }

  function init() {
    var animated = Array.prototype.slice.call(document.querySelectorAll('.fabric-animate'));
    var counters = Array.prototype.slice.call(document.querySelectorAll('[data-fabric-count]'));

    if (reduce || !('IntersectionObserver' in window)) {
      animated.forEach(function (el) { el.classList.add('is-visible'); });
      counters.forEach(function (el) {
        var t = parseFloat(el.getAttribute('data-fabric-count'));
        if (!isNaN(t)) el.textContent = t.toFixed(el.getAttribute('data-fabric-decimals') | 0);
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        if (entry.target.hasAttribute('data-fabric-count')) countUp(entry.target);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });

    animated.forEach(function (el) { io.observe(el); });
    counters.forEach(function (el) { if (!el.classList.contains('fabric-animate')) io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =========================================================================
   Header: transparent-on-homepage + solid-on-scroll + on-scroll menu bar.
   Adds `is-scrolled` to #header-group once the page is scrolled, and
   `header-overlay` when the navbar is in transparent mode (homepage). All
   visual behaviour is driven from CSS via those classes (see custom.css).
   ========================================================================= */
(function () {
  'use strict';

  function initHeader() {
    var header = document.getElementById('header-group');
    if (!header) return;

    var transparentNav = header.querySelector('#navbar-wrapper.navbar-transparent');
    if (transparentNav) {
      header.classList.add('header-overlay');
      var color = transparentNav.style.getPropertyValue('--nav-transparent-color');
      if (color) header.style.setProperty('--nav-transparent-color', color);
    }

    var threshold = 10;
    var ticking = false;

    function update() {
      if (window.scrollY > threshold) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeader);
  } else {
    initHeader();
  }
})();

/* =========================================================================
   Discount code — click to copy
   Delegated from document so it survives the discounts slider being
   re-rendered (Swiper clones slides when looping) and section re-renders in
   the theme editor.
   ========================================================================= */
(function () {
  'use strict';

  var RESET_MS = 1600;

  function setLabel(button, text) {
    var label = button.querySelector('.discount-card-copy-label');
    if (label) label.textContent = text;
  }

  function flash(button) {
    button.classList.add('is-copied');
    setLabel(button, 'Copied');

    if (button._copyTimer) clearTimeout(button._copyTimer);
    button._copyTimer = setTimeout(function () {
      button.classList.remove('is-copied');
      setLabel(button, 'Copy');
    }, RESET_MS);
  }

  /* Fallback for non-secure origins, where navigator.clipboard is undefined. */
  function legacyCopy(text) {
    var area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.top = '-1000px';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();

    var ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (e) {
      ok = false;
    }
    document.body.removeChild(area);
    return ok;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-discount-copy]') : null;
    if (!button) return;

    event.preventDefault();

    var code = button.getAttribute('data-discount-copy') || '';
    if (!code) return;

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(function () {
        flash(button);
      }).catch(function () {
        if (legacyCopy(code)) flash(button);
      });
    } else if (legacyCopy(code)) {
      flash(button);
    }
  });
})();

/* =========================================================================
   Product page discounts rail
   Native scroll-snap carousel: arrows step one card, and it advances on a
   timer when "Auto-rotate" is set. Looping back at the end keeps it endless.
   Pauses on hover/focus so a code can be read and copied.
   ========================================================================= */
(function () {
  'use strict';

  function initRail(wrap) {
    if (wrap.dataset.discountsReady === 'true') return;
    wrap.dataset.discountsReady = 'true';

    var rail = wrap.querySelector('[data-discounts-rail]');
    var prev = wrap.querySelector('[data-discounts-prev]');
    var next = wrap.querySelector('[data-discounts-next]');
    if (!rail) return;

    var seconds = parseFloat(wrap.dataset.autoplay || '0');
    var timer = null;
    var paused = false;

    function step() {
      var card = rail.querySelector('.discount-card');
      if (!card) return 0;
      /* One card plus the gap between cards. */
      var gap = parseFloat(getComputedStyle(rail).columnGap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function atEnd() {
      /* -2px tolerance: sub-pixel widths never land exactly on the maximum. */
      return rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
    }

    function syncArrows() {
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = atEnd();
    }

    function scrollByCard(dir) {
      rail.scrollBy({ left: step() * dir, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });

    rail.addEventListener('scroll', syncArrows, { passive: true });
    syncArrows();

    if (seconds > 0) {
      ['mouseenter', 'focusin', 'touchstart'].forEach(function (evt) {
        wrap.addEventListener(evt, function () { paused = true; }, { passive: true });
      });
      ['mouseleave', 'focusout'].forEach(function (evt) {
        wrap.addEventListener(evt, function () { paused = false; }, { passive: true });
      });

      timer = setInterval(function () {
        if (paused || !rail.isConnected) return;
        /* Only one card in view means nothing to advance to. */
        if (rail.scrollWidth <= rail.clientWidth + 2) return;

        if (atEnd()) {
          rail.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollByCard(1);
        }
      }, seconds * 1000);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-discounts]').forEach(initRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme editor re-renders the block on every setting change. */
  document.addEventListener('shopify:section:load', initAll);
})();

/* =========================================================================
   Burger drawer — keep sub-menus expanded
   The markup ships them open (class="collapse show"), but Bootstrap's
   Collapse plugin owns the state once initialised, so re-assert it whenever
   the drawer opens rather than trusting the initial render.
   ========================================================================= */
(function () {
  'use strict';

  function expandAll(drawer) {
    drawer.querySelectorAll('.collapse-wrapper > .collapse').forEach(function (panel) {
      var toggle = drawer.querySelector('[aria-controls="' + panel.id + '"]');

      /* Prefer the Bootstrap API so the plugin's own state stays in sync;
         fall back to classes if the bundle isn't exposed on window. */
      if (window.bootstrap && window.bootstrap.Collapse) {
        window.bootstrap.Collapse.getOrCreateInstance(panel, { toggle: false }).show();
      } else {
        panel.classList.add('show');
      }

      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    });
  }

  document.addEventListener('shown.bs.offcanvas', function (event) {
    if (event.target && event.target.id === 'offcanvas-menu') expandAll(event.target);
  });

  /* Also on load, for the case where the drawer is already in the DOM open. */
  function initOnce() {
    var drawer = document.getElementById('offcanvas-menu');
    if (drawer) expandAll(drawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOnce);
  } else {
    initOnce();
  }
})();

/* =========================================================================
   Sticky ATC — show sooner
   The theme's StickyATC (product.js) only reveals the bar once the main
   Add to cart block has scrolled off the top of the page. This shows it as
   soon as the shopper starts scrolling, whenever the main Add to cart block
   isn't on screen. The bar keys off .is-visible (see sections.css), so the
   theme's own .show toggling no longer affects it.
   ========================================================================= */
(function () {
  'use strict';

  var SCROLL_START = 60; // px scrolled before the bar may appear

  function init() {
    var bar = document.getElementById('sticky-atc');
    var atc = document.querySelector('.product-main .product-block-atc');
    if (!bar || !atc) return;

    var atcOnScreen = false;
    var ticking = false;

    function update() {
      ticking = false;
      var visible = window.scrollY > SCROLL_START && !atcOnScreen;
      bar.classList.toggle('is-visible', visible);
      /* Runs after the theme's own scroll handler, so this padding wins. */
      document.body.style.paddingBottom = visible ? bar.clientHeight + 'px' : 0;
    }

    function requestUpdate() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    new IntersectionObserver(function (entries) {
      atcOnScreen = entries[0].isIntersecting;
      requestUpdate();
    }).observe(atc);

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    requestUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =========================================================================
   Product card quick add
   <quick-add> (snippets/product-card-actions.liquid). Opens a size picker
   over the card image; once every option is chosen the variant goes straight
   into the bag through the theme's cart-container, which also opens the cart
   drawer. Single-variant products add on the first tap.
   ========================================================================= */
(function () {
  'use strict';

  if (customElements.get('quick-add')) return;

  class QuickAdd extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.trigger = this.querySelector('.pca-quick-add');
      this.panel = this.querySelector('.pca-panel');
      this.status = this.querySelector('.pca-status');
      var json = this.querySelector('script[data-variants]');
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.options = Array.prototype.slice.call(this.querySelectorAll('.pca-option'));
      this.selected = [];

      this.trigger && this.trigger.addEventListener('click', this.onTrigger.bind(this));
      if (!this.panel) return;

      this.querySelector('.pca-close').addEventListener('click', this.close.bind(this));
      this.panel.addEventListener('click', this.onValue.bind(this));
      this.panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') this.close();
      }.bind(this));
      this.refreshAvailability();
    }

    onTrigger() {
      if (this.dataset.singleVariant === 'true') {
        this.add(this.dataset.firstVariantId, this.trigger);
        return;
      }
      this.isOpen() ? this.close() : this.open();
    }

    isOpen() {
      return this.classList.contains('is-open');
    }

    open() {
      document.querySelectorAll('quick-add.is-open').forEach(function (el) {
        if (el !== this) el.close();
      }, this);
      this.selected = [];
      this.refreshAvailability();
      this.status.textContent = this.panel.querySelector('.pca-value:not(:disabled)')
        ? ''
        : (window.theme && window.theme.locales && window.theme.locales.product && window.theme.locales.product.sold_out) || 'Sold out';
      this.panel.removeAttribute('inert');
      this.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');
      var first = this.panel.querySelector('.pca-value:not(:disabled)') || this.panel.querySelector('.pca-close');
      if (first) first.focus({ preventScroll: true });
      QuickAdd.listenOutside();
    }

    close() {
      if (!this.panel) return;
      var hadFocus = this.panel.contains(document.activeElement);
      this.classList.remove('is-open');
      this.panel.setAttribute('inert', '');
      this.trigger.setAttribute('aria-expanded', 'false');
      if (hadFocus) this.trigger.focus({ preventScroll: true });
    }

    onValue(event) {
      var btn = event.target.closest('.pca-value');
      if (!btn || btn.disabled || this._busy) return;

      var position = Number(btn.closest('.pca-option').dataset.position);
      this.selected[position - 1] = btn.dataset.value;
      // A new choice upstream may invalidate later ones.
      this.selected.length = position;
      this.refreshAvailability();

      if (this.selected.length === this.options.length) {
        var chosen = this.selected;
        var variant = this.variants.find(function (v) {
          return v.options.every(function (value, i) { return value === chosen[i]; });
        });
        if (variant && variant.available) {
          this.add(variant.id, btn);
        } else {
          this.status.textContent = 'That combination is sold out';
        }
      } else {
        var next = this.options[this.selected.length].querySelector('.pca-value:not(:disabled)');
        if (next) next.focus({ preventScroll: true });
      }
    }

    // Disable values with no available variant given the choices made so far.
    refreshAvailability() {
      var selected = this.selected;
      var variants = this.variants;
      this.options.forEach(function (option, index) {
        option.querySelectorAll('.pca-value').forEach(function (btn) {
          var value = btn.dataset.value;
          var possible = variants.some(function (v) {
            if (!v.available || v.options[index] !== value) return false;
            for (var i = 0; i < index; i++) {
              if (selected[i] !== undefined && v.options[i] !== selected[i]) return false;
            }
            return true;
          });
          btn.disabled = !possible;
          btn.classList.toggle('is-selected', selected[index] === value);
        });
      });
    }

    async add(variantId, sourceBtn) {
      if (this._busy) return;
      this._busy = true;
      sourceBtn.classList.add('is-loading');
      sourceBtn.setAttribute('aria-busy', 'true');

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      try {
        var cart = document.querySelector('cart-container');
        if (cart && typeof cart.add === 'function') {
          await cart.add(formData);
        } else {
          await fetch(window.Shopify.routes.cart_add_url + '.js', { method: 'POST', body: formData });
          window.location.href = window.Shopify.routes.root_url + 'cart';
        }
        this.close();
      } catch (e) {
        if (this.status) this.status.textContent = 'Could not add to bag — please try again';
      } finally {
        this._busy = false;
        sourceBtn.classList.remove('is-loading');
        sourceBtn.removeAttribute('aria-busy');
      }
    }

    static listenOutside() {
      if (QuickAdd._outside) return;
      QuickAdd._outside = true;
      document.addEventListener('click', function (e) {
        document.querySelectorAll('quick-add.is-open').forEach(function (el) {
          if (!el.contains(e.target)) el.close();
        });
      });
    }
  }

  customElements.define('quick-add', QuickAdd);
})();

/* =========================================================================
   Size low-stock notes (PDP)
   Refreshes the "N left" notes under the size buttons when any option
   changes — a size's stock depends on the other options picked (e.g. Cup).
   Data: <script data-size-stock> in product-block-options.liquid.
   ========================================================================= */
(function () {
  'use strict';

  function update(list) {
    var dataEl = list.parentNode.querySelector('script[data-size-stock]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var max = Number(list.dataset.lowStockMax) || 3;

    var selected = [];
    list.querySelectorAll('input[data-option-position]:checked').forEach(function (input) {
      selected[Number(input.dataset.optionPosition) - 1] = input.value;
    });

    list.querySelectorAll('[data-size-stock-note]').forEach(function (note) {
      var input = note.parentNode.querySelector('input[data-option-position]');
      var pos = Number(input.dataset.optionPosition) - 1;
      var variant = variants.find(function (v) {
        return v.options.every(function (value, i) {
          return i === pos ? value === input.value : (selected[i] === undefined || value === selected[i]);
        });
      });
      var qty = variant && variant.qty;
      note.textContent = qty > 0 && qty <= max ? qty + ' left' : '';
    });
  }

  function init() {
    document.querySelectorAll('.product-options[data-low-stock-max]').forEach(function (list) {
      list.addEventListener('change', function () { update(list); });
      update(list);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
